import {
	ARBOL,
	DATA_GENERAL, 
	ID_DATA_TABLE, 
	LISTAR_POR_PERIODO, 
	PROJECT_DETAILS,
	LIST_HISTORY,
	NAVIGATION_TREE,
	NAVIGATION_TREE_PC,
	PARTY_CONTROL,
	MENSUAL_DETALLE,
	ID_PC,
	TREE_SELECTEDS,
	TREE_SELECTEDS_PC,
	RESET_PROJECT,
	URL_TREE_PC,
	URL_TREE_PROJECT,
	HEADER_NAV,
	CLASSIFICATION_DATA,
	DELETE_TREE,
	TREE_DE,
	TREE_FT,
	CLEAN_TREE_CHILDS,
	MEANS_TABLE,
	URL_TREE_MEANS,
	CLEAN_TREE_MEANS,
	TREE_SELECTEDS_MEANS,
	MEANS_DATA,
	RESET_TREE_PROJECTS,
	RESET_TREE_CLASSIFICATION,
	RESET_RIGHT_INFORMATION,
	RESET_RIGHT_INFORMATION_GRAPHIC,
	TREE_DATA_TAB_3,
	MONTH_RESOURCES,
	RESET_MONTH_RESOURCES,
	PROYECT_DATES,
} from '../constants';
import { cleanDuplicates } from '../utils/data';

const initialState = {
	TreeProyects: [],
	TreeProyectsReady: false,
	TreeCount: [],
	treePartyControl: [],
	TreePCCount: [],
	treeDE: [],
	TreeDECount: [],
	treeFT: [],
	TreeFTCount: [],
	classicationData: [],
	TreeCDCount: [],
	meansTable: null,
	DataCards: [],
	DataPc: [],
	DataMeans: [],
	idCard: null,
	idPc: null,
	graphic: null,
	projectDetails: [],
	listHistory: [],
	treeSelecteds: [],
	treeSelectedsPc: [],
	treeSelectedsMeans: [],
	titleProject: null,
	titlePC: null,
	urlTreePc: '',
	urlTreeMeans: '',
	urlTreeProject: '',
	pc: false,
	treeDataTab3: [],
	monthResources: {
		items: [],
		totalItems: 0,
	},
	dates: [],
};
 // eslint-disable-next-line
export default (state = initialState, { type, payload }) => {
	
	const clasifiedTreeData = (oldData, newData, titleOrder = 'CodProyecto') => {
		const data = [...oldData, ...newData]
		.sort((a, b) => {
			if (a[titleOrder] < b[titleOrder]) {
				return -1;
			} else if (a[titleOrder] > b[titleOrder]) {
				return 1;
			} else {
				return 0;
			}
		});
		return [...new Set(data)];
	}
	switch (type) {

	case ARBOL:
		if ( state.TreeCount.indexOf(payload.part) >= 0 ) 
			return state;
		const parts = [...state.TreeCount, payload.part];
		return { 
			...state,
			TreeProyects: clasifiedTreeData(state.TreeProyects, payload.data),
			TreeCount: parts,
			TreeProyectsReady: parts.length === payload.count,
		};
	case TREE_SELECTEDS:
		let nodeId = payload.nodeId;
		let prevSelected = ( state.treeSelecteds && state.treeSelecteds.indexOf(nodeId) >= 0 );
		let newState = prevSelected
			? payload.forcedOpen !== true 
				? state.treeSelecteds.filter(item => item !== nodeId)
				: [...state.treeSelecteds]
			: [...state.treeSelecteds, nodeId];
		return { 
			...state,
			treeSelecteds: newState,
		};
	
	case TREE_SELECTEDS_PC:
		let nodeIdPc = payload.nodeId;
		let prevSelectedPC = state.treeSelectedsPc.indexOf(nodeIdPc);
		let newStatePc =  prevSelectedPC > -1 && payload.forcedOpen !== true
			? state.treeSelectedsPc.filter(item => item !== nodeIdPc)
			: prevSelectedPC < -1 && payload.forcedOpen === false
				? [...state.treeSelectedsPc]
				: [...state.treeSelectedsPc, nodeIdPc]
		
		
		
		// prevSelectedPC >= 0
		// 	? payload.forcedOpen === undefined
		// 		? state.treeSelectedsPc.splice(prevSelectedPC, 1) //.filter(item => item !== nodeIdPc)
		// 		: [...state.treeSelectedsPc]
		// 	: [...state.treeSelectedsPc, nodeIdPc];

		return { 
			...state,
			treeSelectedsPc: newStatePc,
		};
		
	case TREE_SELECTEDS_MEANS:
		let nodeIdMeans = payload.nodeId;
		let prevSelectedMeans = ( state.treeSelectedsMeans && state.treeSelectedsMeans.indexOf(nodeIdMeans) >= 0 );
		let newStateMeans =  prevSelectedMeans
			? payload.forcedOpen !== true
				? state.treeSelectedsMeans.filter(item => item !== nodeIdMeans)
				: [...state.treeSelectedsMeans]
			: [...state.treeSelectedsMeans, nodeIdMeans];

		return { 
			...state,
			treeSelectedsMeans: newStateMeans,
		};	

	case DATA_GENERAL:
		console.log('DATA_GENERAL', payload);
		return { 
			...state,
			DataCards: payload
		};

	case PROYECT_DATES:
		console.log('PROYECT_DATES', payload);
		return { 
			...state,
			dates: payload.data
		};

	case MENSUAL_DETALLE:
		return { 
			...state,
			DataPc: payload
		};
	
	case MEANS_DATA:
		console.log('MEANS_DATA', payload)
		return { 
			...state,
			DataMeans: payload
		};
	
	case ID_DATA_TABLE:
		return { 
			...state,
			idCard: payload
		};
	
	case ID_PC:
		return { 
			...state,
			idPc: payload
		};	
	
	case LISTAR_POR_PERIODO:
		console.log('LISTAR_POR_PERIODO', payload)
		return { 
			...state,
			graphic: payload
		};
		
	case PROJECT_DETAILS:
		console.log('PROJECT_DETAILS', payload)
		return { 
			...state,
			projectDetails: payload
		};

	case MEANS_TABLE:
		return { 
			...state,
			meansTable: payload
		};

	case LIST_HISTORY:
		return { 
			...state,
			listHistory: payload
		};

	case PARTY_CONTROL:
		if (payload.data.length === 0 || state.TreePCCount.indexOf(payload.part) >= 0 ) {
			return {...state};
		}
		const partsPC = [...state.TreePCCount, payload.part];
		return { 
			...state,
			treePartyControl: clasifiedTreeData(state.treePartyControl, payload.data, 'CodClasificacion'),
			// treePartyControl: payload,
			titlePC: localStorage.getItem('header-pc'),
			titleProject: localStorage.getItem('header-project'),
			TreePCCount: partsPC,
		};
	
	case TREE_DE:
		if ( payload.data.length === 0 || state.TreeDECount.indexOf(payload.part) >= 0 ) 
			return state;
		const partsDE = [...state.TreeDECount, payload.part];
		return { 
			...state,
			treeDE: clasifiedTreeData(state.treeDE, payload.data, 'CodClasificacion'),
			// treeDE: payload,
			TreeDECount: partsDE,
			titlePC: localStorage.getItem('header-pc'),
			titleProject: localStorage.getItem('header-project'),
			
		};	

	case TREE_FT:
		if (payload.data.length === 0 || state.TreeFTCount.indexOf(payload.part) >= 0 ) 
			return state;
		const partsFT = [...state.TreeFTCount, payload.part];
		return { 
			...state,
			treeFT: clasifiedTreeData(state.treeFT, payload.data, 'CodClasificacion'),
			// treeDE: payload,
			TreeFTCount: partsFT,
			titlePC: localStorage.getItem('header-pc'),
			titleProject: localStorage.getItem('header-project'),
			
		};	

	case NAVIGATION_TREE:
		return { 
			...state,
			titleProject: payload.grupo,
		
		};
		
	case NAVIGATION_TREE_PC:
		return { 
			...state,
			titlePC: payload.grupo,
			
		};

	case URL_TREE_PC:
		localStorage.setItem('header-pc', payload);
		return { 
			...state,
			urlTreePc: payload, 
			urlTreeMeans: ''
	};
	
	case URL_TREE_MEANS:
		localStorage.setItem('header-means', payload);
		return { 
			...state,
			urlTreeMeans: payload,
	};

	case URL_TREE_PROJECT:
		return { 
			...state,
			urlTreeProject: payload,
			urlTreePc: '',
			urlTreeMeans: ''
	};

	case HEADER_NAV:
		return{
			...state,
			pc: payload
		}

	case RESET_PROJECT:
		localStorage.removeItem('header-pc');
		localStorage.removeItem('header-project');
		localStorage.removeItem('date-project');
		return{
			...state,
			TreeProyects: [],
			TreeCount: [],
			TreeProyectsReady: false,
			pc: false,
			DataCards: [],
			DataPc: [],
			idCard: null,
			idPc: null,
			graphic: null,
			projectDetails: [],
			listHistory: [],
			treePartyControl: [],
			treeSelecteds: [],
			treeSelectedsPc: [],
			titleProject: null,
			titlePC: null,
			TreePCCount: [],
		}
	
	case RESET_TREE_PROJECTS:
		localStorage.removeItem('header-pc');
		localStorage.removeItem('header-project');
		return{
			...state,
			TreeProyects: [],
			TreeCount: [],
			TreeProyectsReady: false,
			DataCards: [],
			idCard: null,
			graphic: null,
			projectDetails: [],
			listHistory: [],
			titleProject: null,
			treeSelecteds: [],	
		}
	
	case RESET_TREE_CLASSIFICATION:
		// localStorage.removeItem('header-pc');
		// localStorage.removeItem('header-project');
		return{
			...state,
			classicationData: [],
			TreeCDCount: [],
			treeDataTab3: [],
			treeSelectedsMeans: [],
		}

	case CLEAN_TREE_CHILDS:
		return{
			...state,
			treePartyControl: [],
			TreePCCount: [],
			treeDE: [],
			TreeDECount: [],
			treeFT: [],
			TreeFTCount: [],
			classicationData: [],
			TreeCDCount: [],
		}

	case DELETE_TREE:
		return{
			...state,
			// treePartyControl: [],
		}
	case CLEAN_TREE_MEANS:
		return{
			...state,
			treeDataTab3: [],
			classicationData: [],
			TreeCDCount: [],
		}
	case CLASSIFICATION_DATA:
		if ( payload.data.length === 0 || state.TreeCDCount.indexOf(payload.part) >= 0 ) 
			return state;
		const partsCD = [...state.TreeCDCount, payload.part];
		return { 
			...state,
			classicationData: clasifiedTreeData(state.classicationData, payload.data, 'CodInsumo'),
			TreeCDReady: partsCD.length === payload.count,
			TreeCDCount: partsCD,
			
		};
	case TREE_DATA_TAB_3:
		const converTreeArrayToMap = (oldData, newData) => {
			let orderedLevels = oldData;
			for (let i = 0; i < newData.length; i++) {
				const item = newData[i];
				const key = item.Nivel === 1
					? 'Level1'
					: item.PhantomParentId;
				if (!orderedLevels[key]) {
					orderedLevels[key] = [];
				}
				orderedLevels[key].push(item);
			}
			return orderedLevels;
		}
		const newTreeDataTab3 = converTreeArrayToMap(state.treeDataTab3, payload.data);
		return { 
			...state,
			treeDataTab3: newTreeDataTab3,
			
		};

	case RESET_RIGHT_INFORMATION:
		return { 
			...state,
			DataPc: null,
			graphic: null,
			projectDetails: null,
			meansTable: null,
		};
	case RESET_RIGHT_INFORMATION_GRAPHIC:
		return { 
			...state,
			graphic: null,
		};
	case MONTH_RESOURCES:
		console.log('MONTH_RESOURCES', payload);
		return { 
			...state,
			monthResources: {
				...state.monthResources,
				...payload,
				items: cleanDuplicates([
					...state.monthResources?.items || [], 
					...payload?.items || [],
				], 'CodInsumo')
			}
		};
	case RESET_MONTH_RESOURCES:
		return { 
			...state,
			monthResources: {
				items: [],
				totalItems: 0,
			}
		};
	

	default:
		return state
	};
}
